import styled from "styled-components"
import { calculateColors, COLORS } from "./colors"
import Axios from "axios"
import { getSVGStructFromBuffer } from "./helpers"
import { Scrollbar } from "../editSlide/modules/RightPanel/style"
import PerfectScrollbar from 'react-perfect-scrollbar'

const lightMainColor = COLORS.lightBlue
const superLightColor = calculateColors({ firstColor: lightMainColor, secondColor: '#ffffff', amount: 6 })[5]
const superSuperLightColor = calculateColors({ firstColor: superLightColor, secondColor: '#ffffff', amount: 6 })[2]
// const lightMainColorHover = calculateColors({firstColor: lightMainColor, secondColor: '#757575', amount: 20})[1]
const lightMainColorHover = COLORS.lightBlueHover
const mainColorHover = calculateColors({ firstColor: COLORS.deepBlue, secondColor: '#ffffff', amount: 6 })[2]

export const WixUIStyleWrapper = styled.div`
    height: 100%;

    .tabs .tabs-menu {
        background-color: ${superSuperLightColor}!important;
    }

    .tabs .tabs-menu .tab-label.active {
       color: ${COLORS.deepBlue}!important;
       background-color: ${lightMainColor}!important;
       
    }
    .tabs .tabs-menu .tab-label:hover {
        background-color: ${calculateColors({ firstColor: lightMainColor, secondColor: '#ffffff', amount: 20 })[5]}!important;
    }
    .control-button.btn-confirm-primary {
        background-color: ${COLORS.deepBlue}!important;
    }
	.control-button.btn-confirm-primary:hover {
        background-color: ${mainColorHover} !important;
    }

    .control-button.btn-confirm-primary[disabled]{
        background-color: #bcbcbc !important;
    }
    .control-button.btn-confirm-primary:hover[disabled]{
        background-color: #bcbcbc !important;
    }

	.control-button.btn-confirm-secondary {
		color: ${COLORS.deepBlue}!important;
        background-color: ${COLORS.lightBlue} !important;
        &:hover {
            background-color: ${lightMainColorHover} !important;
        }
	}

    .control-button.btn-back {
        color: ${COLORS.deepBlue}!important;
        background-color: ${lightMainColor} !important;
        &:hover {
            background-color: ${lightMainColorHover} !important;
        }
    }

    .image-preview .button-wrapper button.action span {
        color: ${COLORS.deepBlue}!important;
    }
    .image-preview .button-wrapper button.action svg * {
        fill: ${COLORS.deepBlue}!important;
    }

	div.dropdown.combobox:not(.disabled):hover>div.dd>div.selected-container>div.selected, div.dropdown.select:not(.disabled):hover>div.dd>div.selected-container>div.selected {
        color: ${COLORS.deepBlue}!important;
    }

    section.dropdown-options.select>div.options>ol.list>li.option.selected {
        background-color: ${COLORS.deepBlue}!important;
    }

	div.dropdown.combobox>div.dd>i.expand.arrow, div.dropdown.select>div.dd>i.expand.arrow {
        border-color: ${COLORS.deepBlue}!important;
    }

    div.dropdown>div.dd i.arrow .symbol-arrowDown {
        fill: ${COLORS.deepBlue}!important;
    }


    .control-switch .symbol-switch .st1 {
        fill: ${lightMainColor}!important;
    }

    .control-switch .symbol-switch .st2 {
        fill: ${lightMainColorHover}!important;
    }

    .control-switch .symbol-switch .switch-thumb-minus {
        fill: ${lightMainColor}!important;
    }

    .control-switch .input-switch:checked~.symbol-switch .switch-thumb-minus {
        fill: none !important;
    }

    .control-switch .input-switch:checked~.symbol-switch .switch-thumb-check {
        fill: ${COLORS.deepBlue}!important;
    }

	.control-switch .input-switch:checked~.symbol-switch .st1,
    .control-switch .input-switch:checked~.symbol-switch .st2 {
        fill: ${COLORS.deepBlue}  !important;
    }

	.control-buttons-group input:checked+span {
        background-color: ${COLORS.deepBlue}  !important;
    }

    .input-slider .slider .line {
        background-color: ${lightMainColor} !important;
    }

	.input-slider .slider .coloredLine {
        background-color: ${COLORS.deepBlue}  !important;
    }
        
    .input-slider .slider .sliderKnob:after {
        background-color: ${COLORS.deepBlue}  !important;
    }
`


export const RowPicker = (props = { label: 'Label', currentValue: 'value', options: [{ value: 'value', element: (<div></div>) }], onChange: (val) => { } }) => {
    const MainContainer = styled.div`
        padding: 20px 24px;
        color: ${COLORS.darkText};
    `
    const Label = styled.p`
        margin: 0px;
        margin-bottom: 10px;
    `

    const SquareContainer = styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `

    const OptionDiv = styled.div`
        cursor: pointer;
        background: ${props => props.picked ? COLORS.deepBlue : COLORS.lightBlue};
        border-radius: 8px;
        margin-right: 10px;
        padding: 10px 8px;
        height: 50px;
        width: 50px;
        transition: all .1s;
        &:last-of-type {
            margin-right: 0px;
        }
        &:hover {
            background: ${props => props.picked ? calculateColors({ firstColor: COLORS.deepBlue, secondColor: '#000000', amount: 6 })[1] : calculateColors({ firstColor: COLORS.lightBlue, secondColor: COLORS.deepBlue, amount: 6 })[1]};
        }
    `




    return (
        <MainContainer>
            <Label>
                {props.label}
            </Label>
            <SquareContainer>
                {
                    props.options.map((el, index) => {
                        const picked = el.value == props.currentValue
                        return (
                            <OptionDiv
                                key={`option-${index}`}
                                picked={picked}
                                onClick={e => {
                                    props.onChange(el.value)
                                }}
                            >
                                <el.element picked={picked} />
                            </OptionDiv>
                        )
                    })
                }
            </SquareContainer>
        </MainContainer>
    )
}



const DefaultFlex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`
const Dot = styled.div`
    background: ${props => props.picked ? 'rgba(211, 237, 255, .4)' : 'rgba(56, 153, 236, .4)'};
    width: 8px;
    height: 8px;
    border: 0px solid ${props => props.picked ? 'rgba(211, 237, 255, .4)' : 'rgba(56, 153, 236, .4)'};
    &.active {
        background: ${props => props.picked ? 'rgba(211, 237, 255, 1)' : 'rgba(56, 153, 236, 1)'};
        border: 0px solid ${props => props.picked ? 'rgba(211, 237, 255, 1)' : 'rgba(56, 153, 236, 1)'};;
    }
    margin-right: 3px;
    &:last-of-type {
        margin-right: 0px;
    }
`

const SquaredDotsElement = (props = { picked: false }) => {

    return (
        <DefaultFlex>
            <Dot picked={props.picked} />
            <Dot picked={props.picked} className='active' />
            <Dot picked={props.picked} />
        </DefaultFlex>
    )
}

const CircleSolidDotsElement = (props = { picked: false }) => {

    return (
        <DefaultFlex>
            <Dot style={{ borderRadius: '50%' }} picked={props.picked} />
            <Dot style={{ borderRadius: '50%' }} picked={props.picked} className='active' />
            <Dot style={{ borderRadius: '50%' }} picked={props.picked} />
        </DefaultFlex>
    )
}

const CircleStrokeDotsElement = (props = { picked: false }) => {

    return (
        <DefaultFlex>
            <Dot style={{ borderRadius: '50%', borderWidth: '2px', borderColor: props.picked ? 'rgba(211, 237, 255, 1)' : COLORS.deepBlue, background: 'transparent' }} picked={props.picked} />
            <Dot style={{ borderRadius: '50%', borderWidth: '2px', borderColor: props.picked ? 'rgba(211, 237, 255, 1)' : COLORS.deepBlue }} picked={props.picked} className='active' />
            <Dot style={{ borderRadius: '50%', borderWidth: '2px', borderColor: props.picked ? 'rgba(211, 237, 255, 1)' : COLORS.deepBlue, background: 'transparent' }} picked={props.picked} />
        </DefaultFlex>
    )
}

const RectDotsElement = (props = { picked: false }) => {

    return (
        <DefaultFlex>
            <Dot style={{ height: '4px', borderRadius: '8px' }} picked={props.picked} />
            <Dot style={{ height: '4px', borderRadius: '8px' }} picked={props.picked} className='active' />
            <Dot style={{ height: '4px', borderRadius: '8px' }} picked={props.picked} />
        </DefaultFlex>
    )
}

const dotsPickerOptions = [
    { value: 'squared', element: SquaredDotsElement },
    { value: 'circle-solid', element: CircleSolidDotsElement },
    { value: 'circle-stroke', element: CircleStrokeDotsElement },
    { value: 'rect', element: RectDotsElement },
]

export const DotsDesignPicker = (props = { currentValue: '', onChange: (val) => { }, label: 'Choose dots design' }) => {
    return (
        <RowPicker
            options={dotsPickerOptions}
            currentValue={props.currentValue}
            onChange={val => props.onChange(val)}
            label={props.label}
        />
    )
}

const colorButtonDarker = calculateColors({ firstColor: COLORS.lightBlue, secondColor: COLORS.darkLightBlue, amount: 5 })

export const WixStyledButtonPrimary = styled.button`
    background: ${COLORS.deepBlue};
    border: none;
    border-radius: 50px;
    padding: 10px 25px;
    color: #fff;
    margin: 10px 0;
    transition: all .1s;
    &:hover {
        background: ${calculateColors({ firstColor: COLORS.deepBlue, secondColor: '#ffffff', amount: 6 })[2]};
    }
    ${props => props.disabled ?
        `
            background: #bcbcbc;
            pointer-events: none;
            color: #fff;
        `
        : ''
    }
`

export const WixStyledButtonSecondary = styled.button`
    background: ${COLORS.lightBlue};
    border: none;
    border-radius: 50px;
    padding: 10px 25px;
    color: ${COLORS.deepBlue};
    margin: 10px 0;
    transition: all .1s;
    &:hover {
        background: ${colorButtonDarker[1]};
    }
    ${props => props.disabled ?
        `
            background: #bcbcbc;
            pointer-events: none;
            color: #fff;
        `
        : ''
    }
`

export const WixStyledButtonNonFilled = styled.button`
    background: #ffffff;
    border: 1px solid ${COLORS.deepBlue};
    border-radius: 50px;
    padding: 10px 25px;
    color: ${COLORS.deepBlue};
    margin: 10px 0;
    transition: all .1s;
    &:hover {
        background: ${COLORS.deepBlue};
        color: #ffffff;
    }
    ${props => props.disabled ?
        `
            background: #bcbcbc;
            pointer-events: none;
            color: #fff;
            border: none;
        `
        : ''
    }
`

const ButtonIconContainer = styled.div`
    padding: ${props => props.hasPadding ? '8px' : '0px'};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: ${props => props.hasPadding ? 'pointer' : 'default'};
    border: ${props => props.bordered ? `2px ${COLORS.wixGrey} solid` : 'none'};
    border-radius: 4px;
    width: ${props => props.hasPadding ? props.size + 16 : props.size}px;
    height: ${props => props.hasPadding ? props.size + 16 : props.size}px;
    transition: .2s;
    margin-right: ${props => props.location == 'left' ? props.margin : 0}px;
    margin-left: ${props => props.location == 'right' ? props.margin : 0}px;
    &:hover {
        border: ${props => props.bordered ? `2px ${COLORS.deepBlue} solid` : 'none'};
    }

    i {
        font-size: ${props => props.size}px;
    }

    img {
        display: inline-block;
        position: relative;

    }
`


export const ButtonIcon = (props = { icon: 'circle-o', location: 'left', isCustom: false, size: 25, margin: 0, hasPadding: false, bordered: false, onClick: (e) => { } }) => {
    const imgStyle = {
        height: props.size + 'px',
        width: props.size + 'px',
        display: 'block',
        // borderRadius: '4px',
        // border: !isPremium ? '1px solid #AA34CA' : '1px solid #d9e1e8',
    }

    return (
        <ButtonIconContainer
            size={props.size}
            hasPadding={props.hasPadding}
            bordered={props.bordered}
            onClick={e => { if (props.onClick) props.onClick(e) }}
            margin={props.margin}
            location={props.location}
            className='hvr-icon'
        >
            {
                props.isCustom ?
                    <img src={`https://media.wix.com/media/${props.icon}`} style={imgStyle} />
                    : <i className={'fa fa-' + props.icon} aria-hidden="true" />
            }
        </ButtonIconContainer>

    )
}


export class SVGFromDB extends React.Component {
    // (props = { svg: {attributes: [], children: [{attributes: [], tagName: '', children: []}]}, style: {}, size: {width: 50, height: 50} }) => {
    constructor(props) {
        super(props)
        this.state = {
            svg: null
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.svg != this.props.svg) {
            this.setSvgState()
        }
    }

    setSvgState() {
        if (typeof this.props.svg === 'string') {
            console.time(`svg-${this.props.svg}`)
            const sessionStorageCache = JSON.parse(sessionStorage.getItem('svgCache')) || {}
            if (sessionStorageCache[this.props.svg]) {
                console.log('svg from cache')
                this.setState({ svg: sessionStorageCache[this.props.svg] })
                console.timeEnd(`svg-${this.props.svg}`)
                return
            }
            Axios.get(`/api/svg?id=${this.props.svg}&instance=${Wix.Utils.getInstance()}`).then(resp => {
                const svgData = getSVGStructFromBuffer(resp.data.svgContent)
                console.log('svg from server')
                sessionStorageCache[this.props.svg] = svgData
                sessionStorage.setItem('svgCache', JSON.stringify(sessionStorageCache))
                this.setState({ svg: svgData })
                console.timeEnd(`svg-${this.props.svg}`)
            })
        } else {
            this.setState({ svg: this.props.svg })
        }
    }

    componentDidMount() {
        this.setSvgState()
    }

    renderSVGNode(node) {
        return (
            <node.tagName {...node.attributes}>
                {
                    node.children.map(child => {
                        return this.renderSVGNode(child);
                    })
                }
            </node.tagName>
        )
    }

    render() {
        if (this.state.svg === null) return null

        const svg = this.state.svg

        return (
            <svg {...svg.attributes} preserveAspectRatio="none" width={this.props.size.width} height={this.props.size.height} viewBox={svg.attributes.viewBox} style={this.props.style}>
                {
                    svg.children.map(child => {
                        return this.renderSVGNode(child)
                    })
                }
            </svg>
        )
    }

}


const DropdownContainer = styled.div`
    position: relative;
    width: 100%;
    padding: 19px 24px 17px;
    color: ${COLORS.darkText};
`

const DropdownTitle = styled.p`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 2px;
    margin-top: 3px;
`

const DropdownSelectedOption = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    line-height: 36px;
    cursor: pointer;
    &:hover {
        color: ${COLORS.deepBlue};
    }
`

const DropdownListWrapper = styled.div`
    position: absolute;
    top: -135px;
    left: 9px;
    z-index: 1;
    background-color: #ffffff;
    box-shadow: 0 0 22px 0 rgba(22,45,61,.26);
    border-radius: 8px;
    overflow: hidden;
    max-height: 300px;

    div::-webkit-scrollbar {
  width: 6px;
}

/* Track */
div::-webkit-scrollbar-track {
  background: ${COLORS.superLightBlue};
}

/* Handle */
div::-webkit-scrollbar-thumb {
  background: rgba(78,183,245,.7);
}

/* Handle on hover */
div::-webkit-scrollbar-thumb:hover {
  background: ${COLORS.deepBlue};
}
`

const DropdownList = styled.div`    
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
`

const DropdownListItem = styled.div`
    padding: 8px 16px;
    font-size: 12px;
    cursor: pointer;
    transition: .2s;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${props => props.selected ? COLORS.deepBlue : `#ffffff`};
    color: ${props => props.selected ? '#fff' : COLORS.darkText};
    width: 110px;
    margin: 5px;
    border-radius: 8px;
    span {
        display: block;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
        overflow: hidden;
    }
    img {
        width: 100%;
        min-height: 78px;
        display: block;
    }
    &:hover {
        background-color: ${props => props.selected ? COLORS.deepBlue : COLORS.superLightBlue};
    }
`



export class DropdownTileList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.value,
            isOpen: false,
            dropdownWidth: 0,
        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this)
        this.uid = Math.floor(Math.random() * 100000)
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleOutsideClick)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick)

    }

    handleOutsideClick(e) {
        if (this.uid === undefined) return
        const dr = document.querySelector(`#dropdown-${this.uid}`)
        if (!dr) return
        if (!dr.contains(e.target)) {
            this.setState({ isOpen: false })
        }
    }

    toggleDropdown(e) {
        const targetRect = e.currentTarget.getBoundingClientRect()
        this.setState({ dropdownWidth: targetRect.width + 30 });
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };

    selectOption(value) {
        this.setState({ selected: value, isOpen: false });
        this.props.onChange(value);
    };

    render() {
        const selectedOption = this.props.options.find(option => option.value === this.state.selected);
        const hasImgs = this.props.options.some(option => option.imgSrc)
        return (
            <DropdownContainer style={{ position: 'relative', width: '100%' }}>
                <DropdownTitle>
                    <span>{this.props.title}</span>
                </DropdownTitle>
                <DropdownSelectedOption
                    onClick={(e) => this.toggleDropdown(e)}
                >
                    <span>{selectedOption ? selectedOption.label : 'Select an option'}</span>
                    <span
                        style={{ display: 'flex', alignItems: 'center', borderRadius: '50%', border: `2px solid ${COLORS.deepBlue}`, padding: '3px' }}
                    >
                        <svg class="symbol-arrowDown" width="12" height="12" viewBox="135.1 -517.4 1024 1024">
                            <path fill={COLORS.deepBlue} d="M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z" class="c1"></path>
                        </svg>
                    </span>

                </DropdownSelectedOption>
                {this.state.isOpen && (
                    <DropdownListWrapper onScroll={e => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}>
                        <Scrollbar id={`dropdown-${this.uid}`}>
                            {/* <PerfectScrollbar
                                options={{ suppressScrollY: true }}
                                style={{
                                    height: '300px',
                                    width: this.state.dropdownWidth,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    overscrollBehavior: 'contain'
                                }}
                            > */}
                            <div
                                style={{
                                    height: '300px',
                                    width: this.state.dropdownWidth,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    overscrollBehavior: 'contain',
                                    overflowY: 'scroll'
                                }}
                                className="scrollbar"
                            >
                                {this.props.options.map((option, index) => {
                                    const selected = this.state.selected === option.value;
                                    return (
                                        <DropdownListItem
                                            key={`option-${index}`}
                                            selected={selected}
                                            onClick={() => this.selectOption(option.value)}
                                        >
                                            {
                                                hasImgs && option.value !== 'none' &&
                                                <img src={option.imgSrc} />
                                            }
                                            {
                                                option.value === 'none' &&
                                                <svg style={{ borderRadius: '6px', border: `1px solid ${COLORS.superLightBlue}` }} class="thumb-none-symbol" width={'78px'} height={'78px'} xmlns="http://www.w3.org/2000/svg"><line stroke="red" class="line" y1="100%" x2="100%"></line></svg>
                                            }
                                            <span>{option.label}</span>
                                        </DropdownListItem>
                                    );
                                })}
                            </div>

                            {/* </PerfectScrollbar> */}
                        </Scrollbar>
                    </DropdownListWrapper>

                )}
            </DropdownContainer>
        );
    }
}